import { render, staticRenderFns } from "./Servico.vue?vue&type=template&id=7e27ddfe&scoped=true&"
import script from "./Servico.vue?vue&type=script&lang=ts&"
export * from "./Servico.vue?vue&type=script&lang=ts&"
import style0 from "./Servico.vue?vue&type=style&index=0&id=7e27ddfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e27ddfe",
  null
  
)

export default component.exports